import { useMutation, useQuery } from "@tanstack/react-query";
import { Tag } from "antd"; // Import Antd Modal and Button
import React, { useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { MdOutlineCheck } from "react-icons/md";
import {
  getProjectWiseUploadedListAllBucketPath,
  getProjectWiseUploadedListByEmail,
  runFinalEDADataQc,
} from "../../../../api/apiCallManager";
import AccessTo from "../../../../components/is-show/AccessTo";
import Loader from "../../../../components/spinner/Loader";
import WrapperLoader from "../../../../components/spinner/WrapperLoader";
import { showError, showSuccess } from "../../../../helpers/alerts";
import { FL, PA } from "../../../router/AddRoutesJson";
import ShowClientEDA from "./ShowClientEDA";
import { CONSTANT_CLIENT_PROGRESS_STATUS } from "./rowConstantStatus";
import LogScriptRunErrorModal from "./LogScriptRunError";
import useSelectedServerVersionStore from "../../../../components/hooks/useSelectedServerVersionStore";

function FinalEdaCel({ rowItems, infraFormData }) {
  const [isDisabled, setIsDisable] = useState(false);
  const [showLogError, setShowLogError] = useState(false);
  const {
    selectedServerVersionZustandState,
    setSelectedServerVersionZustandState,
  } = useSelectedServerVersionStore();
  const onRunError = (data) => {
    setShowLogError(Math.random);
    showError("Run Failed", data?.body);
    setIsDisable(false);
  };
  const runMutation = useMutation({
    mutationFn: runFinalEDADataQc,
    onSuccess: (data) => {
      if (data.statusCode == 200) {
        showSuccess("Script Running...");
        setIsDisable(true);
      } else {
        onRunError(data);
      }
    },
    onError: (error) => {
      onRunError(error);
    },
  });

  const allFormattedTable = infraFormData?.map((client) => ({
    // infra: client.infra,
    clientName: client.clientName,
    // clientManager: client?.clientManager,
    // project_key: client?.infra[0]?.project_key,
    instanceName: client.name,
    // siteManager: client?.siteManager,
  }));
  const formattedData = {
    projectKey: rowItems?.project_key,
    clients: allFormattedTable?.filter((item) => item.clientName !== ""),
    server: allFormattedTable?.filter((item) => item.clientName === ""),
    event_type: "final_eda_script_run",
  };
  const addVersionToClientsAndServer = (data) => {
    if (data) {
      // Add the version to clients
      data.clients = data?.clients?.map((client) => ({
        ...client,
        version: rowItems?.client_version,
      }));

      // Add the version to servers
      data.server = data?.server?.map((server) => ({
        ...server,
        version: selectedServerVersionZustandState,
      }));

      return data;
    }
  };

  const updatedData = addVersionToClientsAndServer(formattedData);
  // const fetchUploadedList = useMutation({
  //   mutationFn: () =>
  //     getProjectWiseUploadedListByEmail(rowItems?.siteManager?.email),
  //   onError: (error) => {
  //     showError(`Please re-try: ${error.message}`); // Show error alert
  //   },
  //   onSuccess: (data) => {
  //     const payload = {
  //       projectKey: rowItems?.infra[0]?.project_key,
  //       clients: allFormattedTable?.filter((item) => item.clientName !== ""),
  //       server: allFormattedTable?.filter((item) => item.clientName === ""),
  //       event_type: "final_eda_script_run",
  //     };
  //     console.log(payload);
  //     const filteredFiles =
  //       data?.filter(
  //         (file) => file?.siteName === rowItems?.siteManager?.siteName
  //       ) || [];

  //     if (filteredFiles.length) {
  //       const payload = {
  //         projectKey: rowItems.infra[0].project_key,
  //         clients: allFormattedTable?.filter((item) => item.clientName !== ""),
  //         server: allFormattedTable?.filter((item) => item.clientName === ""),
  //         event_type: "final_eda_script_run",
  //       };

  //       // runMutation.mutate(payload);
  //     } else {
  //       showError("Something Went Wrong! Please retry!");
  //     }
  //   },
  // });

  const handleRun = () => {
    runMutation.mutate(updatedData);
  };

  const renderStatusComponent = (status) => {
    switch (true) {
      case CONSTANT_CLIENT_PROGRESS_STATUS.RUNNING?.includes(status):
        return <Tag color="green">Running</Tag>;
      case CONSTANT_CLIENT_PROGRESS_STATUS.PENDING?.includes(status):
        return (
          <AccessTo
            role={[FL]}
            fallBackComponent={<Tag color="orange"> Run Enabled</Tag>}
          >
            <button
              disabled={isDisabled}
              className="bg-green-600 text-white  px-2 rounded-sm"
              onClick={() => handleRun()}
            >
              {runMutation.isPending ? (
                <Loader isLoading={runMutation.isPending} />
              ) : (
                "Run"
              )}
            </button>
          </AccessTo>
        );

      case CONSTANT_CLIENT_PROGRESS_STATUS.SUCCESS?.includes(status):
        return (
          <AccessTo
            role={[FL, PA]}
            fallBackComponent={<MdOutlineCheck color="green" size={16} />}
          >
            <ShowClientEDA edaResource={rowItems?.final_eda?.resource} />
          </AccessTo>
        );
      default:
        return <IoCloseOutline color="red" size={16} />; // Default case for other statuses
    }
  };

  return (
    <div className="flex justify-center">
      {/* {JSON.stringify(infraFormData)} */}
      {/* {JSON.stringify(uploadedListData)}====== */}
      {/* {JSON.stringify(allFormattedTable)} */}
      {/* <button onClick={() => handleRun(allFormattedTable)}>oj</button> */}
      <LogScriptRunErrorModal
        scriptType={"final-eda"}
        rowItems={rowItems}
        showLogError={showLogError}
        setShowLogError={setShowLogError}
      />

      {/* {JSON.stringify(rowItems)} */}

      <WrapperLoader isLoading={!rowItems?.final_eda?.status}>
        {renderStatusComponent(rowItems?.final_eda?.status)}
      </WrapperLoader>
    </div>
  );
}

export default FinalEdaCel;
